import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'cd-mobile-nav',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './cd-mobile-nav.html',
  styleUrl: './cd-mobile-nav.scss',
})
export class CdMobileNav {
  open = input(false);
  closed = output<void>();

  close() {
    this.closed.emit();
  }
}
